import { scenesStatusAdapter, ScenesStatusState } from './scenes-status.entity';
import { createReducer, on, Action } from '@ngrx/store';
import { scenesStatusActions } from './scenes-status.actions';
import { LoggingService } from '../../../services/logging.service';

export const initialState: ScenesStatusState = scenesStatusAdapter.getInitialState({
    ids: [],
    entities: null,
    loaded: false
});

export const ScenesStatusReducerObj = createReducer(
    initialState,

    on(scenesStatusActions.loadScenesStatusSuccess, (state, action) => {
        if (action.ScenesStatus && action.ScenesStatus !== null && action.ScenesStatus.length > 0) {
            return scenesStatusAdapter.addAll(action.ScenesStatus, {
                ...state,
                loaded: action.ScenesStatus && action.ScenesStatus !== null ? action.ScenesStatus.length > 0 : false,
                error: null
            });
        }
        else {
            return {
                ...state,
                loaded: false,
                error: null
            }
        }

    }),

    on(scenesStatusActions.loadScenesStatusFail, (state, action) => {

        LoggingService.log(action.error);
        return {
            ...state,
            error: action.error
        }
    }),

    on(scenesStatusActions.clear, (state, action) => {
        return scenesStatusAdapter.removeAll(state);
    }),
);

export function reducer(state: ScenesStatusState = initialState, action: Action): ScenesStatusState {
    return ScenesStatusReducerObj(state, action);
}

export const ScenesStatusSelectors = scenesStatusAdapter.getSelectors();
